import { render, staticRenderFns } from "./sendForgetPasswordEmail.vue?vue&type=template&id=4647d828&scoped=true&"
import script from "./sendForgetPasswordEmail.vue?vue&type=script&lang=js&"
export * from "./sendForgetPasswordEmail.vue?vue&type=script&lang=js&"
import style0 from "./sendForgetPasswordEmail.vue?vue&type=style&index=0&id=4647d828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4647d828",
  null
  
)

export default component.exports